import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LayoutShellComponent } from './layout/layout-shell.component';
import { AgentHomeChatComponent } from './agenthome-chat/agenthome-chat.component';
// Workspace (formerly Data Hub) is lazy-loaded — reports + event data. Apps
// (formerly More Apps) hosts every interactive app, including License
// Extensions. Routes are registered unconditionally: surface visibility is a
// RUNTIME flag served by GET /agenthome/me (config-repo flags.json), which
// gates the nav links — every surface's CONTENT is already access-filtered
// server-side, so a direct URL can never over-expose.
import { authGuard } from './shared/guards/auth.guard';
import { authoriseGuard } from './shared/guards/authorise.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: LayoutShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'chat' },
      { path: 'chat', component: AgentHomeChatComponent, canActivate: [authoriseGuard], data: { screenKey: 'AGENTS' } },
      { path: 'workspace', loadComponent: () => import('./features/data-hub/data-hub.component').then(m => m.DataHubComponent), canActivate: [authoriseGuard], data: { screenKey: 'AGENTS_DATA' } },
      // /apps route + all app feature dirs migrated to wg-agents-apps-ui in
      // 2026-08. The sidebar Apps tile now opens the apps portal in a new tab.
      { path: 'dashboards', loadComponent: () => import('./dashboards/dashboards-gallery.component').then(m => m.DashboardsGalleryComponent), canActivate: [authoriseGuard], data: { screenKey: 'AGENTS' } },
      { path: 'abilities', loadComponent: () => import('./features/abilities/abilities.component').then(m => m.AbilitiesComponent), canActivate: [authoriseGuard], data: { screenKey: 'AGENTS' } },
      // Per-user OAuth connectors. Connections is a MODAL (mounted in the
      // layout shell) — this route is kept because it is the OAuth return
      // target allowlisted on the AgentCore workload identity, and because
      // old bookmarks point at it. It opens the modal and redirects to chat.
      { path: 'connections', loadComponent: () => import('./features/connections/connections-entry.component').then(m => m.ConnectionsEntryComponent), canActivate: [authoriseGuard], data: { screenKey: 'AGENTS' } },
      // Legacy deep links (bookmarks, emails) keep working.
      { path: 'data-hub', redirectTo: 'workspace' },
      { path: '**', redirectTo: 'chat' }
    ]
  }
];
